// @ts-nocheck


import { createSlice } from '@reduxjs/toolkit';



export const SET_MONITORING_VEHICLES = 'vehicles/monitoring/set';





const initialState = {
  monitoringVehicles: []
};

const monitoringSlice = createSlice({
  name: 'vehicles/monitoring',
  initialState,
  reducers: {
    set: (state, { payload }) => {
      return {
        ...state,
        monitoringVehicles: payload
      };
    }
  }
});

export const monitoringActions = monitoringSlice.actions;

export const fetchMonitoringVehicles = () => async (dispatch) => {
  dispatch(monitoringActions.set([]));
};

export const cleanMonitoringVehicles = () => (dispatch) => {
  dispatch(monitoringActions.set([]));
};

export default monitoringSlice.reducer;
